import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Tabs,
  Tab
} from '@mui/material';
import {
  Message as MessageIcon,
  VideoCall as VideoCallIcon,
  Notifications as NotificationsIcon
} from '@mui/icons-material';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

/**
 * Client Communication Main Page
 * Provides navigation to different communication channels
 */
const ClientCommunication: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = React.useState(0);

  // Update active tab based on current route
  React.useEffect(() => {
    const path = location.pathname;
    if (path.includes('/messages')) setActiveTab(0);
    else if (path.includes('/calls')) setActiveTab(1);
    else if (path.includes('/updates')) setActiveTab(2);
    else setActiveTab(0); // default to messages
  }, [location.pathname]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
    const routes = ['messages', 'calls', 'updates'];
    navigate(`/dashboard/client/communication/${routes[newValue]}`);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Communication
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Stay connected with your project team
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            aria-label="communication tabs"
            sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
          >
            <Tab
              label="Messages"
              icon={<MessageIcon />}
              iconPosition="start"
            />
            <Tab
              label="Video Calls"
              icon={<VideoCallIcon />}
              iconPosition="start"
            />
            <Tab
              label="Project Updates"
              icon={<NotificationsIcon />}
              iconPosition="start"
            />
          </Tabs>

          <Outlet />
        </CardContent>
      </Card>
    </Container>
  );
};

export default ClientCommunication;